import config from '../config';
import { customFetch, authHeader, jsonHeader, handleResponse, commonRequestOptions } from '../helpers';

const endpointPath = 'app_config'

// Client for the generic per-app config API (core.app_config). Grouped by settings area;
// webhooks first. Add sibling methods for a new area rather than a new service module.
export const appConfigService = {
    getWebhooks,
    upsertWebhook,
    removeWebhook,
};

function getWebhooks(signal) {
    const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/webhook`, requestOptions, signal).then(handleResponse);
}

function upsertWebhook(payload, signal) {
    const requestOptions = { method: 'PUT', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions(), body: JSON.stringify(payload) };
    return customFetch(`${config.api.url}/${endpointPath}/webhook`, requestOptions, signal).then(handleResponse);
}

function removeWebhook(scope, signal) {
    const requestOptions = { method: 'DELETE', headers: authHeader(), ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/webhook/${encodeURIComponent(scope)}`, requestOptions, signal).then(handleResponse);
}
